export const MOBILE_UNIT_TYPES_NO = {
    MDR_SE2: 20,
    EL_MDR_SE2_IN: 59,
    EL_MDR_SE2_OUT: 60,
    EL_MDK_SE2_IN: 61,
    EL_MDK_SE2_OUT: 62,
    MKR: 26
};


export const isMobileCapable = (unitTypeNo: number): boolean => {
    return Object.values(MOBILE_UNIT_TYPES_NO).includes(unitTypeNo);
}